import { useTranslation } from 'react-i18next';
import { Check, Copy } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

import { cn } from '@/lib/utils';

import { useCopyText } from '@/hooks';

type CopyValueProps = {
  value: string;
  className?: string;
};

export const CopyValue = (props: CopyValueProps) => {
  const { value, className } = props;
  const { t } = useTranslation();
  const { isCopied, copy } = useCopyText();

  return (
    <Tooltip open={isCopied}>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => copy(value)}
          className={cn(
            'bg-muted hover:bg-accent text-foreground inline-flex h-6 max-w-60 cursor-pointer items-center gap-1.5 rounded-md px-1.5 font-mono text-xs transition-colors',
            className,
          )}
        >
          <span className="min-w-0 flex-1 truncate text-left">{value}</span>
          {isCopied ? (
            <Check className="text-success-soft-foreground size-3 shrink-0" />
          ) : (
            <Copy className="text-muted-foreground size-3 shrink-0" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>{t('Copied')}</TooltipContent>
    </Tooltip>
  );
};
